// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_gr-6";
export var emphasizeQuantity = "_gr-3";
export var flatBottomCorners = "_gr-5";
export var productImage = "_gr-0";
export var quantityContainer = "_gr-2";
export var tooltip = "_gr-1";
export var wrapAndEllipsesOverflow = "_gr-4";